/* src/app/front-layout/bridge-course/bridge-course.component.css */
.bootcamp-section {
  background:
    linear-gradient(
      180deg,
      #f79c41 0%,
      #f3f9ed 100%);
  padding: 40px 0 0 0;
  border-radius: 0;
  min-height: 400px;
}
.bootcamp-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 370px;
}
.bootcamp-text {
  color: #fff;
}
.bootcamp-text .highlight {
  font-size: 5.5rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.1;
  letter-spacing: 1px;
}
.subtitle {
  margin-top: 24px;
  font-size: 2.3rem;
  font-weight: 600;
  color: #18181b;
  letter-spacing: 0.5px;
}
.bootcamp-img img {
  max-height: 540px;
  width: auto;
  border-radius: 0;
  display: block;
}
.trending-section {
  padding: 40px;
  margin: 32px 8px;
}
.section-title {
  font-size: 4rem;
  font-weight: 600;
  margin-bottom: 18px;
  color: #111;
}
.courses-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 36px 32px;
}
.course-card {
  display: flex;
  align-items: flex-start;
  background: #eeeeee;
  box-shadow: 5px 4px 8px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  padding: 16px 20px;
}
.course-image img {
  width: 220px;
  object-fit: contain;
  border-radius: 10px;
  margin-right: 26px;
}
.course-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.course-title {
  font-weight: bold;
  font-size: 2.23rem;
  margin-bottom: 0.2rem;
}
.course-title .highlight {
  color: #18a1f5;
  font-size: 2.23rem;
  font-weight: 600;
}
.feature {
  margin: 0 0 0.8rem 0;
  padding: 0;
  list-style: none;
  font-size: 1.5rem;
}
.feature li {
  margin: 0.1rem 0;
}
.price-row {
  font-size: 2.5rem;
  margin-bottom: 0.9rem;
  margin-top: 6px;
  font-weight: 600;
}
.price-label {
  color: #111;
  margin-right: 7px;
}
.price-value {
  color: #111;
  font-size: 3.25rem;
  font-weight: 700;
}
.price-suffix {
  font-size: 3rem;
  font-weight: 400;
}
.course-actions {
  display: flex;
  gap: 13px;
}
.book-btn {
  background: #0077b6;
  color: #fff;
  border: none;
  border-radius: 21px;
  font-size: 1.7rem;
  font-weight: 600;
  padding: 6px 22px;
  cursor: pointer;
  transition: background 0.2s;
}
.book-btn:hover {
  background: #4291d6;
}
.details-btn {
  background: #7dd63a;
  color: #fff;
  border: none;
  border-radius: 21px;
  font-size: 1.7rem;
  font-weight: 600;
  padding: 6px 22px;
  cursor: pointer;
  transition: background 0.2s;
}
.details-btn:hover {
  background: #a2f75c;
}
@media (max-width: 768px) {
  .bootcamp-content {
    margin-top: 60px;
    flex-direction: column;
    text-align: center;
  }
  .bootcamp-text .highlight {
    font-size: 2.5rem;
    line-height: 1.2;
  }
  .subtitle {
    font-size: 1.8rem;
    margin-top: 15px;
  }
  .bootcamp-img img {
    max-height: 350px;
    margin-top: 20px;
    max-width: 100%;
  }
  .trending-section {
    padding: 20px 15px;
    margin: 20px 0;
  }
  .courses-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .section-title {
    font-size: 2.8rem;
    text-align: center;
    margin-bottom: 25px;
  }
  .course-card {
    flex-direction: column;
    align-items: center;
    padding: 20px 15px;
  }
  .course-image img {
    width: 100%;
    max-width: 280px;
    margin: 0 0 20px 0;
  }
  .course-title {
    font-size: 1.8rem;
    text-align: center;
  }
  .course-title .highlight {
    font-size: 1.8rem;
  }
  .feature {
    font-size: 1.3rem;
    margin-bottom: 15px;
  }
  .price-row {
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 15px;
  }
  .price-value {
    font-size: 2.2rem;
  }
  .price-suffix {
    font-size: 1.8rem;
  }
  .course-actions {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
  .book-btn,
  .details-btn {
    width: 100%;
    max-width: 250px;
    padding: 10px;
    font-size: 1.5rem;
    text-align: center;
  }
}
/*# sourceMappingURL=bridge-course.component.css.map */
